import ImageOne from './2.png';
import ImageTwo from './3.jpg';
import ImageThree from './4.jpg';
import ImageFour from './5.jpg';
import ImageFive from './6.jpg';
import ImageSeven from './5.jpg';

export const MusicCovers = [ ImageOne, ImageTwo, ImageThree, ImageFour, ImageFive, ImageSeven ];
